import axios from 'axios';

import { CommonConfig } from '../../../../config/common-config';

export const testService = (data) => {
    return axios
        .post(`${CommonConfig.dev.baseUrl}/api/auth/login`, data)
        .then((response) => response.data)
        .catch((error) => {
            // console.warn("FAILED to get all employees due to", error.toString());
            return Promise.reject(error);
        });
};

export const forgotPassword = (data) => {
    return (
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/forgot-password `, data)
            .then((response) => response.data)
            // this.setState({ successMsg: 'Login Credentials are updated!!!' });
            .catch((error) => {
                // this.setState({ restPwdErrorMsg: 'correct credentials needed!!!' });
                // console.warn("FAILED to get all employees due to", error.toString());
            })
    );
};

export const getIMCDetails = () => {
    return (
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`)
            .then((response) => response.data)
            // this.setState({ successMsg: 'Login Credentials are updated!!!' });
            .catch((error) => {
                // this.setState({ restPwdErrorMsg: 'correct credentials needed!!!' });
                // console.warn("FAILED to get all employees due to", error.toString());
            })
    );
};
